import axios from "axios";
import {laravelRoute} from "../../util/common";
const state = {
    ids: [],
    all: [],
    current_page: 1,
    per_page: 25,
    from: 1,
    to: 50,
    last_page: null,
    total: null,
};

// getters
const getters = {
    all: (state, getters, rootState) => {
        return state.all;
    },
    ids: (state, getters, rootState) => {
        return state.ids;
    }
};

// actions
const actions = {
    async get({commit, state}, args) {
        const search_args = Object.assign({
            page: state.current_page,
            per_page: state.per_page,
        }, args);
        let data;
        try{
            let url = laravelRoute('vehicle-stock.requests');
            let response = await axios.get(url, search_args);
            data = response.data;
            commit('setData', data);
        } catch (e) {
            //
        }
        return data;
    },
};

// mutations
const mutations = {
    setData(state, result) {
        state.all = result.data;
        state.current_page = result.current_page;
        state.per_page = parseInt(result.per_page);
        state.from = result.from;
        state.to = result.to;
        state.last_page = result.last_page;
        state.total = result.total;
    },

};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./resources/js/store/modules/vehicleStockRequests.js